import { useQuery } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseGetServicesCategoriesResponse } from "../utils/types";

const useGetServiceCategoriesQuery = (): IUseGetServicesCategoriesResponse => {
  return useQuery({
    queryKey: ["service-categories"],
    queryFn: async (data) => {
      const response = await AXIOS_RESERVATION.get(
        "v1/coupons/service-categories",
        data
      );
      return response.data;
    },
  });
};

export default useGetServiceCategoriesQuery;
